import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import styles from './RatingView.module.scss'

const cx = classnames.bind(styles)

const MAX_DOTS = 5;

const RatingView = function (props) {
  const {
    value,
    total = MAX_DOTS,
    vote,
    showTotal = false,
    className,
  } = props;

  const rates = useMemo(function () {
    return new Array(total).fill(0).map((el, i) => {
      if (value > i + 0.5) {
        return 'red'
      }
      if (value > i){
        return 'half'
      }
      return 'inactive'
    })
  }, [value, total])

  return (
    <div className={cx('rating-view', className)}>
      <div className={cx('rate-wrap')}>
        {rates.map((rateIco, i) => <span key={i} className={cx('rate', rateIco)} />)}
      </div>
      <span className={cx('counter')}>
        {value}/{total}
      </span>
      {showTotal && (<span>({vote})</span>)}
    </div>
  )
}

RatingView.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  total: PropTypes.number,
  vote: PropTypes.number.isRequired,
  className: PropTypes.string,
  showTotal: PropTypes.bool,
}

export default RatingView
